export var MISSIONS_GAMEPLAY_STATE_NOT_FOUND_ERROR = 'MISSIONS_GAMEPLAY_STATE_NOT_FOUND';
export var EVENTS_GAMEPLAY_STATE_NOT_FOUND_ERROR = 'EVENTS_GAMEPLAY_STATE_NOT_FOUND';